<template>
  <div class="CYTMemorabilia">
    <img class="visitor-floor-img" src="@/assets/aboutCYT1.jpg" alt="" />
    <img class="visitor-floor-img" src="@/assets/aboutCYT1.jpg" alt="" />
    <div class="memorabilia-title">{{ isEnglish ? 'CYT Memorabilia' : '春阳台大事记' }}</div>
    <div class="memorabilia-info">
      <div class="memorabilia-time">
        <div class="memorabilia-time-info" v-for="yearData in filteredMemorabiliaData" :key="yearData.year">
          {{ yearData.year }}
        </div>
      </div>
      <div class="memorabilia-line"></div>
      <div class="memorabilia-thing">
        <div class="thing-body" v-for="yearData in memorabiliaData" :key="yearData.year">
          <div v-for="item in yearData.data" :key="item.id">
            <div class="thing-round"></div>
            <div class="thing-info">
              <div class="thing-info-title" v-html="isEnglish ? item.contentEn : item.contentCn"></div>
              <div class="thing-info-time">{{ formatDate(item.createTime) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CYTMemorabilia",
  data() {
    return {
      donationList: [],
      pageList: [],
      currentIndex: 0,
      pageIndex: 1,
      pageSize: 6,
      total: 0,
      maxPageIndex: 1,
      lan: this.$store.state.isEn,
      memorabiliaData: [], // 存储从接口获取的大事记数据
    };
  },
  computed: {
    isEnglish() {
      return this.lan === 1;
    },
    // 过滤出有数据的年份
    filteredMemorabiliaData() {
      return this.memorabiliaData.filter(yearData => yearData.data.length > 0);
    },
  },
  watch: {
    pageIndex(val, oldval) {

    },
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
  },
  created() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.getMemorabiliaData(); // 调用方法获取数据
  },
  methods: {
    // 替换中文双引号为英文双引号
    replaceChineseQuotes(text) {
      if (!text) return text;
      // 处理HTML实体编码的中文双引号
      let result = text.replace(/&ldquo;/g, '"');
      result = result.replace(/&rdquo;/g, '"');
      // 处理直接的中文引号字符
      result = result.replace(/[“”‘’]/g, '"');
      return result;
    },

    // 从接口获取大事记数据
    getMemorabiliaData() {
      // 使用项目中正确的API调用方式
      this.$api.get('/memorabilia/list', {}, res => {
        if (res.code === 0) {
          this.memorabiliaData = res.data.map(yearData => ({
            ...yearData,
            data: yearData.data.map(item => ({
              ...item,
              contentEn: this.replaceChineseQuotes(item.contentEn)
            }))
          }));
        }
      }, err => {
        // 移除console语句以通过ESLint检查
      });
    },
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    },
  },
};
</script>
<style scoped>
.CYTMemorabilia {
  position: relative;
  margin-top: 5%;
}
.memorabilia-title {
  position: absolute;
  top: 72px;
  left: 240px;
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: left;
  font-weight: 700;
}
.memorabilia-info {
  position: absolute;
  top: 160px;
  left: 240px;
  width: 100%;
  height: 800px;
  background-color: #fff;
}
.memorabilia-info {
  display: flex;

}
.memorabilia-thing {
  margin-top: 120px;

  width: 1080px;
}
.memorabilia-time {
  margin-top: 100px;
  width: 280px;
}
.memorabilia-line{
  margin-top: 128px;
  background: #D8D8D8;
  width: 2px;
  height: 532px;
}
.memorabilia-time-info {
  margin-bottom: 280px;
  padding-right: 33px;
  font-family: SourceHanSansCN-Light;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: right;
  font-weight: 200;
}
.thing-body{
  display: flex;
  margin-bottom: 60px;
}
.thing-round{
  background: #CA9D76;
  width: 10px;
  height: 10px;
  margin-left: -6px;
  margin-top: 5px;
  border-radius: 50%;
}
.thing-info{
  margin-left: 63px;
}
@media (max-width: 960px) {
}
@media (max-width: 768px) {
}
@media (max-width: 480px) {
}
</style>
